import React from "react";
import "../style/sidebarstudent.css";
import Logo from "../assets/images/whitelogo.png";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";


const SidebarStudent = () => {
  const navigate = useNavigate();

  const handleNavigate = (address) =>{
    navigate(address);
  }

  const Logout = () => {
    Swal.fire({
      title: "Logout",
      text: "Are you sure want to logout ?",
      icon: "warning",
      background: "white",
      color: "black",
      backdrop: `rgba(131, 131, 131, 0.5)`,
      showCancelButton: true,
      confirmButtonColor: "#0004ff",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        confirmButton: "custom-btn-sweetalrt",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete("/logoutstudent");
        } catch (error) {
        } finally {
          navigate("/loginstudent");
        }
      }
    });
  };
  return (
    <div className="custom-con-sidebar-student position-fixed top-0 start-0">
      <div className="custom-con-img-logo-sidebar-student position-relative top-0 start-50 translate-middle-x">
        <img
          className="adjust-logo-sidebar-student object-fit-contain"
          src={Logo}
          alt="logo.png"
        />
      </div>
      <div className="custom-con-bg-menu-sidebar-student-active position-relative start-50 top-0 translate-middle-x d-flex" onClick={()=>handleNavigate("/profilepage")}>
        <i className="bi bi-person-fill"></i>
        <p className="custom-text-menu-sidebar-student">Profile</p>
      </div>
      <div className="custom-con-bg-logout-sidebar-student position-absolute start-50 bottom-0 translate-middle-x d-flex" onClick={()=>Logout()}>
        <i className="bi bi-box-arrow-right custom-logo-logout-student"></i>
        <p className="custom-text-menu-sidebar-student custom-text-logout-student">
          Logout
        </p>
      </div>
    </div>
  );
};

export default SidebarStudent;
